<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">NAT Port Forwarding</h4>
       
        <p>Current Port Forwarding Table:</p>
        <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table">
            <el-table-column prop="address" label="Local IP Address" ></el-table-column>
            <el-table-column prop="range" label="Local Port Range" ></el-table-column>
            <el-table-column prop="protocol" label="Protocol" ></el-table-column>
            <el-table-column prop="rAddress" label="Remote IP Address"></el-table-column>
            <el-table-column prop="rRange" label="Remote Port Range"></el-table-column>
            <el-table-column prop="name" label="Wan Name" v-if="enable"></el-table-column>
            <el-table-column prop="status" label="Status" ></el-table-column>
            <el-table-column prop="comment" label="Comment" ></el-table-column>
            <el-table-column prop="" label="Select">
                <template slot-scope="scope">
                    <el-button
                        @click.native.prevent="deleteRow(scope.$index, tableData)"
                        type="text"
                        :disabled="$G_DEVICE_CFG.isReadOnly"
                        size="small">
                        Delete
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
         
         <div class="btn-contain">
            <el-button type="primary" @click="dialogFormVisible = true" :disabled="$G_DEVICE_CFG.isReadOnly">Add</el-button>
        </div>

        <el-dialog title="" :visible.sync="dialogFormVisible" width="40%" :lock-scroll="false" >
            <div class="change">
                <i for="">Enable Port Forwarding:</i>
                <!-- <el-checkbox v-model="form.flag" class="bigCheck" :disabled="false"></el-checkbox> -->
                <el-switch v-model="form.flag" ></el-switch>
            </div>
             
            <el-form :inline-message="true" :rules="rules" ref="forms" :model="form" style="width:93%;" 
            :disabled="$G_DEVICE_CFG.isReadOnly || !form.flag" size="mini">
                <el-form-item label="Interface Selection" :label-width="formLabelWidth" >
                    <el-select v-model="form.name" placeholder="Please select" style="width: 100%">
                         <el-option v-for="(item,index) in selList" :key="index" :value="item.value" :label="item.label"></el-option>
                     </el-select>
                </el-form-item>
               <el-form-item label="Local IP Address:" :label-width="formLabelWidth" prop="address">
                    <el-input v-model="form.address" auto-complete="off" ></el-input>
                </el-form-item>
                <el-form-item label="Local Port Range:" :label-width="formLabelWidth">
                  <el-col :span="11">
                    <el-form-item prop="range1">
                      <el-input v-model.number="form.range1" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2" style="text-align:center;">-</el-col>
                  <el-col :span="11">
                    <el-form-item prop="range2">
                      <el-input v-model.number="form.range2" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-col>
                     
                </el-form-item>
                  <el-form-item label="Protocol:" :label-width="formLabelWidth" >
                    <el-select v-model="form.protocol" placeholder="Please select" style="width: 100%">
                         <el-option v-for="item in protocolList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                     </el-select>
                </el-form-item>
                 <el-form-item label="Remote IP Address:" :label-width="formLabelWidth" prop="rAddress">
                    <el-input v-model="form.rAddress" auto-complete="off" ></el-input>
                </el-form-item>
                <el-form-item label="Remote Port Range:" :label-width="formLabelWidth">
                      <el-col :span="11">
                    <el-form-item prop="rRange1">
                     <el-input v-model.number="form.rRange1" auto-complete="off" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2" style="text-align:center;">-</el-col>
                  <el-col :span="11">
                    <el-form-item prop="rRange2">
                      <el-input v-model.number="form.rRange2" auto-complete="off" ></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>
                <el-form-item label="Comment:" :label-width="formLabelWidth" prop="comment">
                    <el-input v-model="form.comment" auto-complete="off" maxlength="20"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="add">Confirm</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
  data() {
    return {
      enable: false,
      dialogFormVisible: false,
      loading: false,
      mask: "",
      form: {
        flag: true,
        address: "",
        range1: "",
        range2: "",
        protocol: "0",
        rAddress: "",
        rRange1: "",
        rRange2: "",
        name: "WAN1",
        status: "",
        comment: ""
      },
      formLabelWidth: "180px",
      selList: [],
      protocolList: [
        { value: "0", label: "Both" },
        { value: "1", label: "TCP" },
        { value: "2", label: "UDP" }
      ],
      data: [],
      tableData: [],
      rules: {
        address: [
            {
            validator: (rule, value, callback) => {
              if (!validator.isIP(value) ) {
                callback(new Error("IP address value error!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        range1: [
          {
            type: "number",
            min: 1,
            max: 65535,
            message:
              "range cannot be empty! You should set a value between 1-65535！",
            trigger: "blur"
          }
        ],
        range2: [
          {
            type: "number",
            min: 1,
            max: 65535,
            message:
              "range cannot be empty! You should set a value between 1-65535！",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (value<this.form.range1) {
                callback(new Error("Invalid port range! 1st port value should be less than 2nd value!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        rAddress: [
          {
            validator: (rule, value, callback) => {
                if(value === '') // 允许Remote IP Address 为空
                    callback()
                else if (!validator.isIP(value) ) {
                    callback(new Error("Remote IP address value error!"))
                } else {
                    callback()
                }
            },
            trigger: "blur"
          }
          ],
        rRange1: [
          {
            type: "number",
            min: 1,
            max: 65535,
            message:
              "range cannot be empty! You should set a value between 1-65535！",
            trigger: "blur"
          }
        ],
        rRange2: [
          {
            type: "number",
            min: 1,
            max: 65535,
            message:
              "range cannot be empty! You should set a value between 1-65535！",
            trigger: "blur"
          },
           {
            validator: (rule, value, callback) => {
              if (value<this.form.rRange1) {
                callback(new Error("Invalid port range! 1st port value should be less than 2nd value!"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    deleteRow(index, rows) {
      if (index == "all") {
        this.del(index);
      } else {
        this.del(index + 1);
      }
    },
    del(index) {
      if (index == "all") {
        var postData = {
          Delete_All: "Delete All",
          submit_url: "/portfw.htm"
        };
      } else {
        var postData = {
          deleteSelPortFw: "Delete Selected",
          submit_url: "/portfw.htm"
        };
        var name = `select${index}`;
        postData[name] = "ON";
      }

      this.loading = true;
      axios.post("/boafrm/setformPortFw", postData).then(res => {
        this.loading = false;
        this.$message.success(res.data.msg);
        this.getData();
      });
    },
    getData() {
      let postData = {
        CmdType: "GET_WANLISTS"
      };
      this.loading = true;
      axios.post("/boafrm/fhPingInfo", postData).then(res => {
        this.loading = false;
        var data = res.data;
        if (data.ret == "0") {
          this.selList = [];
          for (var i = 0; i < data.wanLists.length; i++) {
            this.selList.push({
              label: data.wanLists[i].name,
              value: `WAN${i + 1}`
            });
          }
        } else {
          this.$message.error(`ata acquisition error! Error message:${data.errorMsg}`);
        }
      });
      this.loading = true;
      axios.post("/boafrm/getPortForwardStatus").then(res => {
        this.loading = false;
        let data = res.data;
        this.data = data;
        this.mask = data.mask;
     
        this.tableData = [];
        for (var i = 0; i < data.table.length - 1; i++) {
          if (data.table[i].wanBuf != undefined) {
            this.enable = true;
            this.tableData.push({
              address: data.table[i].ip_buff,
              range: data.table[i].portRange,
              protocol: data.table[i].type,
              rAddress: data.table[i].rmt_ip_buff,
              rRange: data.table[i].extPortRange,
              name: data.table[i].wanBuf,
              status: data.table[i].enabled,
              comment: data.table[i].comment
            });
          } else {
            this.enable = false;
            this.tableData.push({
              address: data.table[i].ip_buff,
              range: data.table[i].portRange,
              protocol: data.table[i].type,
              rAddress: data.table[i].rmt_ip_buff,
              rRange: data.table[i].extPortRange,
              status: data.table[i].enabled,
              comment: data.table[i].comment
            });
          }
        }
      });
    },
    add() {
      var flag = true;
      let postData = {
        lan_mask: this.mask,
        enabled: this.form.flag == true ? "ON" : "",
        wanIndex: this.form.name,
        ip: this.form.address,
        fromPort: this.form.range1,
        toPort: this.form.range2,
        protocol: this.form.protocol,
        rmtip: this.form.rAddress,
        externelFromPort: this.form.rRange1,
        externelToPort: this.form.rRange2,
        comment: this.form.comment,
        addPortFw: "Save",
        addPortFwFlag: 1,
        "submit-url": "/portfw.htm"
      };

      if (
        !this.form.flag ||
        (this.form.address == "" &&
          this.form.range1 == "" &&
          this.form.range2 == "" &&
          this.form.comment == "")
      ) {
        this.loading = true;
        this.dialogFormVisible = false;
        axios.post("/boafrm/setformPortFw", postData).then(res => {
          this.loading = false;
          this.$message.success(res.data.msg);
          this.getData();
        });
        return;
      }


      this.$refs["forms"].validate(valid => {
        if (valid) {
          this.loading = true;
            this.dialogFormVisible = false;
          axios.post("/boafrm/setformPortFw", postData).then(res => {
            this.loading = false;
            this.$message(res.data.msg);
             this.$refs["forms"].resetFields();
            this.getData();
          });
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {
  h4 {
    margin-bottom: 15px;
  }
  p {
    margin-bottom: 15px;
  }
  .change {
    margin-bottom: 45px;
  }
  .btn-contain {
    width: 100%;
    margin-top: 25px;
    text-align: center;
    padding: 0;
  }
  .change {
    margin-bottom: 22px;
    i {
      align-self: flex-start;
      width: 180px;
      text-align: right;
      font-size: 14px;
      color: #606266;
      padding-right: 12px;
      font-weight: bold;
      opacity: 1;
      white-space: nowrap;
    }
  }
}
</style>



